<template>
  <div>
    <input
      ref="input"
      :key="show"
      type="file"
      class="d-none"
      @change="handleChange"
    >
    <!-- Upload -->
    <div v-show="step === 0">
      <div
        class="image-upload__container"
        @click="selectImage"
      >
        <base-icon icon="image-upload" />
        <div class="image-upload__text">
          <strong>Upload an image </strong> for your profile pic
        </div>
      </div>
    </div>
    <!-- Crop -->
    <div
      v-show="step === 1"
    >
      <!-- style="padding-left: 32px; padding-right: 32px;" -->
      <div
        ref="container"
        class="avatar-editor__container"
        :style="{'height': isCircle ? `calc(${height}px + 170px)`:`calc(${height}px + 73px)`}"
        @contextmenu.prevent.stop="onShowContextMenu"
      >
        <transition
          name="fade"
          appear
        >
          <div
            v-if="loadingImage"
            class="avatar-editor__loader"
          >
            <font-awesome-icon
              class="spinner"
              icon="spinner"
              spin
            />
          </div>
        </transition>
        <transition
          name="fade"
          appear
        >
          <div
            v-if="loading"
            class="loading_spinner"
          >
            <font-awesome-icon
              class="spinner"
              icon="spinner"
              color="white"
              size="2x"
              spin
            />
          </div>
        </transition>
        <div
          ref="mask"
          :class="isCircle ? 'avatar-editor__circle_mask' : 'avatar-editor__square_mask'"
          :style="{&quot;width&quot;: `${width}px`, &quot;height&quot;: isCircle ? `${height}px` :`calc(${height}px + 22px)`}"
        />
        <img
          ref="image"
          class="avatar-editor__img"
          :src="sourceImgUrl"
          :style="imgStyles"
          alt=""
          draggable="false"
          @drag="preventDefault"
          @dragstart="preventDefault"
          @dragend="preventDefault"
          @dragleave="preventDefault"
          @dragover="preventDefault"
          @dragenter="preventDefault"
          @drop="preventDefault"
          @mousedown="imgStartMoving"
          @mousemove="imgMove"
          @mouseup="imgStopMoving"
          @mouseout="imgStopMoving"
          @touchstart="imgStartMoving"
          @touchmove="imgMove"
          @touchend="imgStopMoving"
          @touchcancel="imgStopMoving"
        >
        <div class="slider__wrapper">
          <base-tooltip
            v-show="!isCircle"
            class="tooltipbg"
            :offset="[25, 28]"
            text="Remove Background"
          >
            <div class="removebg">
              <base-icon
                style="width: 12px; height: 14px;"
                icon="remove-background"
                @click="removeBackground"
              />
            </div>
          </base-tooltip>
          <div class="slider__container">
            <touch-range
              ref="touchRange"
              v-model="zoom"
              :class-name="'slider'"
              :min="10"
              :max="100"
              @input="createImage()"
            />
            <div
              class="slider__empty"
              :style="sliderPosition"
            />
          </div>
        </div>
      </div>
      <button
        v-if="debug"
        @click="createImage()"
      >
        createImage
      </button>
      <canvas
        ref="canvas"
        crossorigin="anonymous"
        :class="{'d-none': !debug}"
        :width="2 * width"
        :height="2 * height"
      />
    </div>
    <!-- Context menu (right click) -->
    <!-- <base-context-menu
      ref="contextMenu"
      :items="contextMenuItems"
    /> -->
    <slot name="extraData" />
    <add-link-modal
      ref="addLinkModal"
      :value="productUrl"
      @input="$emit('product-url-changed', $event)"
    />
  </div>
</template>

<script>
import { imageProcessingService } from '@/_services';
import AddLinkModal from '@/components/ImageBox/AddLinkModal';
import TouchRange from './TouchRange';

export default {
  name: 'ImageEditor',
  components: {
    AddLinkModal,
    TouchRange,
  },
  props: {
    editorTitle: {
      type: String,
      default: 'Edit Profile Picture',
    },
    preFilledImage: {
      type: String,
      default: '',
    },
    secondaryActionText: {
      type: String,
      default: 'Change Image',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    initialStep: {
      type: Number,
      default: 0, // 0: uploader | 1: Crop
    },
    isCircle: {
      type: Boolean,
      default: true,
    },
    fitToMask: {
      type: Boolean,
      default: true,
    },
    productUrl: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 238,
    },
    height: {
      type: Number,
      default: 238,
    },
  },
  data() {
    return {
      loading: false,
      debug: false,
      show: false, // Shows the modal
      imgDataUrl: '', // the datebase64 url of created image
      sourceImgUrl: '', // Uploaded image
      createImgUrl: '', // Created image
      step: 0, // 0: uploader | 1: Crop
      isDragging: false,
      loadingImage: true,
      imgPosition: {
        left: 0,
        top: 0,
      },
      zoom: 100,
      initial: {},
      localProductUrl: '',
    };
  },
  computed: {
    imgStyles() {
      return {
        // Slider is 57px tall
        transform: `translate3d(${this.imgPosition.left}px, 
        calc(${this.imgPosition.top}px - 57px/2), 0px) scale(${this.zoom / 100})`,
        // transform: `translate3d(${this.imgPosition.left}px, ${this.imgPosition.top}px, 0px) scale(${this.zoom / 100})`,
      };
    },
    contextMenuItems() {
      return [{
        label: 'Remove Background',
        icon: 'remove-background',
        action: this.removeBackground,
      },
      /*
      , {
        label: 'Add Link',
        icon: 'add-link',
        action: this.openLinkModal,
      } */
      ];
    },
    sliderPosition() {
      const sliderWidth = (this.$refs.touchRange)
      && this.$refs.touchRange.$refs.slider
        ? this.$refs.touchRange.$refs.slider.getBoundingClientRect().width
        : 0;
      const min = 10;
      const max = 100;
      const thumbWidth = 12;
      const position = (((this.zoom - min) / (max - min))
        * ((sliderWidth - thumbWidth / 2)
        - thumbWidth / 2
        )) + thumbWidth;
      return { left: `${position}px` };
    },
  },
  watch: {
    initialStep: {
      handler(value) {
        this.step = value;
      },
      immediate: true,
    },
    preFilledImage: {
      handler(value) {
        if (value) {
          this.sourceImgUrl = value;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // EventBus.$on('avatar-editor--close', () => {
    //   this.close();
    // });
    // EventBus.$on('avatar-editor--open', () => {
    //   this.close();
    // });

    this.$refs.image.onload = () => {
      if (this.fitToMask) {
        setTimeout(() => {
          this.loadingImage = false;
          this.doFitToMask();
          this.createImage();
        }, 200);
      }
    };
  },
  methods: {
    openLinkModal() {
      this.$nextTick().then(() => {
        this.$refs.addLinkModal.open();
      });
    },
    removeBackground() {
      this.loading = true;
      imageProcessingService.removeBackground(this.sourceImgUrl).then((s3url) => {
        console.log('S3Url: ', s3url);
        this.sourceImgUrl = s3url;
      }).finally(() => {
        this.loading = false;
      });
    },
    onShowContextMenu(evt) {
      this.$nextTick().then(() => {
        this.$refs.contextMenu.show(evt);
      });
    },
    checkAction() {
      if (this.secondaryActionText === 'Change Image') {
        return this.selectImage();
      }
      if (this.secondaryActionText === 'Cancel Image') {
        return this.$emit('cancel-selection');
      }
      return '';
    },
    open() {
      this.show = true;
    },
    close() {
      this.$emit('close-editor');
      this.show = false;
    },
    selectImage() {
      this.$refs.input.click();
    },
    preventDefault(e) {
      e.preventDefault();
      return false;
    },
    // Upload
    handleChange(e) {
      e.preventDefault();
      if (this.loading !== 1) {
        const files = e.target.files || e.dataTransfer.files;
        this.setSourceImg(files[0]);
      }
    },
    setStep(step) {
      this.$nextTick().then(() => {
        this.step = step;
        this.$emit('change-step', step);
      });
    },
    setSourceImg(file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.sourceImgUrl = reader.result;
        this.setStep(1);
      };
      reader.readAsDataURL(file);
    },
    resetComponent() {
      this.show = false;
      this.$emit('close-editor');
      this.imgDataUrl = '';
      this.sourceImgUrl = '';
      this.createImgUrl = '';
    },
    reset() {
      const image = this.$refs.image.getBoundingClientRect();
      const container = this.$refs.container.getBoundingClientRect();

      this.imgPosition.left = (container.width / 2) - (image.width / 2);
      this.imgPosition.top = (container.height / 2) - (image.height / 2);
      this.zoom = 100;
    },
    doFitToMask() {
      const { image } = this.$refs;
      const mask = this.$refs.mask.getBoundingClientRect();
      const container = this.$refs.container.getBoundingClientRect();

      this.imgPosition.left = (container.width / 2) - (image.width / 2);
      this.imgPosition.top = (container.height / 2) - (image.height / 2);

      this.zoom = Math.ceil((mask.width * 100) / image.width);
    },
    // Crop
    imgStartMoving(e) {
      e.preventDefault();
      this.isDragging = true;
      this.initial.screenX = e.screenX || e.targetTouches[0]?.screenX;
      this.initial.screenY = e.screenY || e.targetTouches[0]?.screenY;
      this.initial.left = this.imgPosition.left;
      this.initial.top = this.imgPosition.top;
    },
    imgMove(e) {
      e.preventDefault();
      if (!this.isDragging) {
        return;
      }

      const moveX = (e.screenX || e.targetTouches[0]?.screenX) - this.initial.screenX;
      const moveY = (e.screenY || e.targetTouches[0]?.screenY) - this.initial.screenY;

      const posLeft = this.initial.left + moveX;
      const posTop = this.initial.top + moveY;

      // Constrains X
      // if (posLeft > 264) {
      //   this.imgPosition.left = 264 / scale
      // } else if ((posLeft + width) < 502) {
      //   this.imgPosition.left = 502 - width;
      // } else {
      this.imgPosition.left = posLeft;
      // }

      // Constrains Y
      // if (posTop > 0) {
      //   this.imgPosition.top = 0
      // } else if ((posTop + height) < 240) {
      //   this.imgPosition.top = 240 - height;
      // } else {
      this.imgPosition.top = posTop;
      // }
    },
    imgStopMoving(e) {
      e.preventDefault();
      this.isDragging = false;
      // console.log(e);
      this.createImage();
    },
    createImage() {
      const { sourceImgUrl } = this;
      const { canvas } = this.$refs;
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, 2 * this.width, 2 * this.height);
      ctx.fillStyle = 'rgba(255,255,255,1)';
      ctx.fillRect(0, 0, 2 * this.width, 2 * this.height);

      // Create and add image on canvas
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = sourceImgUrl;

      img.onload = () => {
        const imageRect = this.$refs.image.getBoundingClientRect();
        const maskRect = this.$refs.mask.getBoundingClientRect();

        const leftPost = imageRect.x - maskRect.x;
        const topPost = imageRect.y - maskRect.y;

        ctx.drawImage(
          img,
          2 * leftPost,
          2 * topPost,
          2 * imageRect.width,
          2 * imageRect.height,
        );
        this.imgDataUrl = canvas.toDataURL('image/jpeg', 1.0);
      };
    },
    async upload() {
      if (this.isLoading) {
        return;
      }
      const file = this.imgToFile(this.imgDataUrl, 'image/jpeg');
      this.$emit('change-avatar', {
        image: this.imgDataUrl,
        file,
      });
    },
    imgToFile(rowData, mime) {
      const data = window.atob(rowData.split(',')[1]);
      const ia = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i += 1) {
        ia[i] = data.charCodeAt(i);
      }
      return new Blob([ia], {
        type: mime,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
#imageCrop::v-deep .modal-dialog{
  min-width: 800px !important;
  @media (min-width: 576px){
    max-width: 800px !important;
  }
}
.image-upload{
  &__container{
    background-color: $gray-light;
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
  }
  &__text{
    margin-top: 1rem;
    font-size: 0.875rem;
    font-family: $font-family-sans-serif-light;
    strong{
      color: #E9AD7D;
    }
  }
}
.avatar-editor {
    &__container {
        position: relative;
        display: block;
        width: 100%;
        // height: calc(240px + 57px); // Slider is 57px tall
        // background-color: #e5e5e0;
        background-color: transparent;
        overflow: hidden;
    }
    &__loader{
        background-color: #333333;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: 9999;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        .spinner{
          color: rgba(white, 0.3);
        }
    }
    &__img {
        position: absolute;
        display: block;
        cursor: move;
        user-select: none;
        max-width: 1000px;
        background: white;
        // min-height: 240px;
        // min-width: 240px;
    }
    &__circle_mask {
      border-radius: 50%;
      background: transparent;
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 19%;
      transform: translateX(-50%);
      overflow: hidden;
      box-shadow: 0px 0px 0px 1000px rgba(black, 0.7);
      pointer-events: none;
    }
    &__square_mask {
      background: transparent;
      position: absolute;
      z-index: 1;
      left: 50%;
      top: 1px;
      transform: translateX(-50%);
      overflow: hidden;
      box-shadow: 0px 0px 0px 1000px rgba(black, 0.7);
      pointer-events: none;
    }
}
.delete-avatar__btn{
  //color: $gray-light-2;
  color: #333333;
  font-size: 0.875rem;
  cursor: pointer;
}

.slider__wrapper {
  &:before {
    content: "Min";
    color: white;
    margin-right: 15px;
    vertical-align: middle;
    font-size: 12px;
    margin-bottom: 6px;
    font-family: $font-family-sans-serif-medium;
  }
  &:after {
    content: "Max";
    color: white;
    margin-left: 15px;
    vertical-align: middle;
    font-size: 12px;
    margin-bottom: 6px;
    font-family: $font-family-sans-serif-medium;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  padding-top: 15px;
  padding-bottom: 7px;
  z-index: 1;
  border-top: 1px solid rgba(white, 0.2);
  bottom: 0;
  text-align: center;
  width: 100%;
}
.slider {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: transparent;
    -webkit-appearance: none;    /* removes default webkit styles */

    appearance: none;
    width: 357px;
    height: 2px;
    opacity: 0.7;
    outline: none;
    transition: opacity .2s;   /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: .2s;
  &__empty{
    position: absolute;
    top: 9px;
    left: 0;
    width: 1000px;
    height: 2px;
    background-color: gray;
  }
   &__container{
    position: relative;
    overflow: hidden;
  }
}
.slider::-webkit-slider-runnable-track {
    width: 357px;
    min-width: 100px;
    height: 2px;
    background: $clementine;
    border: none;
    /*border-radius: 2px;*/
}
.slider:hover {
  opacity: 1;
  /* Fully shown on mouse-over */
}
.slider__empty{
  background-color: #E2E2E2;
}
.slider::-webkit-slider-thumb {
-webkit-appearance: none;
  appearance: none;
  width: 12px;
  height: 12px;
  background: $clementine;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -5px;
}
.slider::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: $clementine;
  border-radius: 50%;
  cursor: pointer;
}
.loading_spinner{
  padding: 10px;
  display: inline-block;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  z-index: 9999;
  justify-content: center;
  align-items: center;
}
.base-context-menu {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  border-radius: 4px !important;
}
.removebg{
  position: absolute;
  z-index: 1;
  left: 16px;
  background-color: #FFFFFF;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -10px;
}
.tooltipbg{
  position: absolute;
  z-index: 1;
  left: 0;
}

</style>
